import { createIcon } from '../createIcon';

export const VialIconConfig = {
  name: 'VialIcon',
  height: 512,
  width: 480,
  svgPath: 'M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const VialIcon = createIcon(VialIconConfig);

export default VialIcon;